import picsioConfig from '../../../../../config';

/** Color label settings exist only in the main Pics.io app. */
export default function isColorLabelSettingsAvailable() {
  return Boolean(picsioConfig.isMainApp && !picsioConfig.isPim);
}
